
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"28","height":"28","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M46.056 17.087l.658-1.324 1.268-.761-1.325-.658-.761-1.268-.657 1.325-1.268.761 1.324.657zm-14.964-6.773l.898-1.81 1.733-1.039-1.81-.898-1.039-1.733-.898 1.81-1.732 1.039 1.809.898zm-13.708 6.705l.635-1.28 1.225-.734-1.28-.635-.734-1.225-.635 1.279-1.225.735 1.279.635zm22.102 2.033l-.897.538.937.465.538.896.464-.936.897-.538-.936-.465-.538-.897zM58.685 35.92c-.027-.028-5.65-9.322-5.687-9.339a1.027 1.027 0 00-.606-.43l-15.758-3.54a1 1 0 00-.439 1.952l11.699 2.627-16.165 4.141-15.482-4.209 9.597-2.151a1 1 0 00-.437-1.951l-13.535 3.033a1.148 1.148 0 00-.63.447l-5.92 9.47a1.007 1.007 0 00.575 1.492l5.543 1.578V54.2a1 1 0 00.758.97l19.24 4.8a1.252 1.252 0 00.507-.005l8.8-2.03a1 1 0 10-.45-1.95l-7.573 1.748V36.435l3.342 6.378a.995.995 0 001.159.498l13.947-3.947v14.1l-6.876 1.592a1 1 0 00.452 1.949l7.65-1.77a1 1 0 00.774-.975V38.798l4.933-1.396a1.007 1.007 0 00.582-1.481zM30.722 57.73L13.44 53.42V39.61c-.169-.054 4.077 1.19 3.8 1.041a1.003 1.003 0 00.275-1.962l-9.792-2.787 4.823-7.713 17.736 4.822-4.076 8.151-4.692-1.333a1 1 0 00-.547 1.924l5.49 1.56a1.002 1.002 0 001.167-.515l3.098-6.194zm6.737-16.564l-4.269-8.145 18.51-4.74 4.592 7.555z","fill":"#fff","data-original":"#000000"}}),_c('path',{attrs:{"d":"M32.448 28.996a1 1 0 001-1.007c-.073-11.444 8.211-14.734 8.564-14.869a1 1 0 00-.704-1.872c-.1.037-9.942 3.872-9.86 16.755a1 1 0 001 .993zm-12.332-18.57c.353.135 8.637 3.425 8.564 14.869a1 1 0 002 .014c.083-12.883-9.76-16.718-9.86-16.755a1 1 0 00-.704 1.872z","fill":"#fff","data-original":"#000000"}})])
          )
        }
      }
    